import { type FC, Suspense, type SuspenseProps } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState.ts';

export const ClientSuspense: FC<SuspenseProps> = ({ fallback, children }) => {
    const isClient = useClientState();

    if (isClient) {
        return <Suspense fallback={fallback}>{children}</Suspense>;
    }

    return <>{fallback}</>;
};
